export enum AssignQaActionEnum {
  Assign = 'Assign',
}
